import { Injectable, inject } from '@angular/core';

import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import type { EmailProviderData } from '@core/email-providers-types';
import { EmailProviders } from '@core/email-providers-types';
import type { EmailProvider } from '@core/email-templates-types';
import { HttpApiService } from '@core/http-legacy';

const supportedEmailProviders = [
  EmailProviders.Google,
  EmailProviders.Microsoft,
  EmailProviders.Mailbox,
];

@Injectable({ providedIn: 'root' })
export class EmailProvidersHttpClient {
  protected readonly httpApi = inject(HttpApiService);

  public fetchCollection(): Observable<EmailProvider> {
    return this.httpApi.get(`/email_provider`).pipe(
      map(data => {
        const emailProvider = data.emailProvider;
        return {
          ...emailProvider,
          connectionError: this.getConnectionError(emailProvider),
        };
      }),
    );
  }

  public update(body: Partial<EmailProviderData>): Observable<EmailProvider> {
    return this.httpApi
      .patch(`/email_provider`, null, {
        email_provider: body,
      })
      .pipe(
        map(data => {
          const emailProvider = data.emailProvider;
          return {
            ...emailProvider,
            connectionError: this.getConnectionError(emailProvider),
          };
        }),
      );
  }

  public updateAutoForward(autoForward: boolean): Observable<EmailProvider> {
    return this.httpApi
      .patch(`/email_provider/toggle`, null, { emailProvider: { autoForward } })
      .pipe(
        map(data => {
          const emailProvider = data.emailProvider;
          return {
            ...emailProvider,
            connectionError: this.getConnectionError(emailProvider),
          };
        }),
      );
  }

  private getConnectionError(emailProvider: EmailProvider): boolean {
    return (
      emailProvider &&
      supportedEmailProviders.includes(<EmailProviders>emailProvider.provider) &&
      !emailProvider.connected
    );
  }
}
